import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Fieldset } from 'primeng/fieldset';
import { OverlayPanel } from 'primeng/overlaypanel';
import { EntitiesService } from 'src/app/configuration/entities.service';
import { LoginService } from 'src/app/login/login.service';
import { LoaderService } from '../../../loader/loader.service';
import { ComponentService } from '../../component.service';
import { ViewsService } from '../../views.service';
import { ViewComponentConfigureComponent } from '../configure/view-component-configure.component';

@Component({
  selector: 'app-view-component-card',
  templateUrl: 'view-component-card.component.html',
  styleUrls: ['view-component-card.component.scss'],
})
export class ViewComponentCardComponent implements OnInit {

  @Output() onEvent: EventEmitter<any> = new EventEmitter();

  @ViewChild('opColumns') opColumns: OverlayPanel;
  
  @Input("component") public component:any = {};
  @Input("index") public index:number = 0;
  @Input("model") public model:any = {};
  @Input("showConfigOptions") public showConfigOptions:boolean = false;
  public temporalModel:any = {};
  public entity:any = {};
  private lastGridEvent: any;
  public loading:boolean = false;
  public totalRows:number = 0;
  public rows:any = Array<any>();
  public user_id: number;
  public today: string;
  public locked: boolean = false;

  public visibleByOptions: any[] = [
    { code: "all", label: "Todos" },
    { code: "user", label: "El usuario responsable" }
  ];

  public fieldType: string = "title";
  public allowedEntities: any[] = [];
  public allowedEntitiesFields: any[] = [];

  constructor(
    private loaderService:LoaderService,
    private entitiesService:EntitiesService,
    private messageService:MessageService,
    private viewsService:ViewsService,
    private datePipe:DatePipe,
    private dialogService:DialogService,
    private loginService: LoginService,
    public componentService:ComponentService
  ) { 
  }

  ngOnInit(): void {
    this.user_id = parseInt(this.loginService.get("userId"));
    this.today = new Date().toISOString();
    this.component.fields.forEach(field => {
      
      if(typeof field.model_property != "undefined"){
        this.temporalModel[field.model_property] = eval("this.model." + field.model_property);
      }
      
    });

    this.entitiesService.getByCode(this.component.entity).subscribe(
      data => {
        this.entity = data;
        this.component.fields.forEach(field => {
          field.entityField = this.entity.fields.find(m=>m.id == field.entity_field_id);
        });
        
        var newFields: any = [];
        if(this.component.avatar!=null){
          if(this.component.avatar.type == "initials"){
            this.component.avatar.fields.forEach(field => {                            
              field.entityField = this.entity.fields.find(m => m.id == field.entity_field_id && !field.entityField.is_disabled);
              if(field.entityField!=null && typeof(field.entityField) !== "undefined" && !field.entityField.is_disabled) newFields.push(field);
            });
            this.component.avatar.fields = newFields;
          }
        }        
        //this.lazyLoad();
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
  }
  

  getModelValue(model, field){
      var value = "";      

      this.temporalModel[field.entityField?.model_property] = eval("model." + field.entityField?.model_property);
      value = this.temporalModel[field.entityField?.model_property];      

    return value;
  }

  formatDate(value: any, args: any) {
    return this.datePipe.transform(value, args[1]);
  }
  formatSuffix(value:any, args:any[]){
    return value + args[1];
  }
  formatPhone(value:any, args:any[]){
    if(value==null || value.length == 0) return "";
    var formattedValue = "<a href='phone:"+ value +"'>" + value + "</a>";
    return formattedValue;
  }  
  formatMail(value:any, args:any[]){
    if(value==null || value.length == 0) return "";
    var formattedValue = "<a href='mailto:"+ value +"'>" + value + "</a>";
    return formattedValue;
  }
  formatBadge(field: any, row: any, value: any, args: any[]) {
    if (value == null) return "";
    let className = "";
    let subClassName = "";
    if (field) {
      let refValue = "";
      if (args[1] != "") {
        try {
          let valorID = eval("row." + field.model_property);
          subClassName = args[1] + valorID;
        } catch (e) {
          console.error(`Error evaluando this.model.${field.entityField.model_property}`);
        }
      }
      /*className = "badge badge-block " + subClassName;
      var formattedValue = "<div class='" + className + "'>" + value + "</div>";*/
      if (typeof (value) !== "undefined" && value != "" && value != null) {
        className = "p-badge p-component p-badge-no-gutter p-badge-xs  p-mr-2 " + subClassName;
        var formattedValue = "<div class='" + className + "' title='" + value + "'></div>" + value;
      } else {
        var formattedValue = "<div></div>";
      }
    }

    return formattedValue;
    /*
    if (value == null) return "";
    let className = "";
    if (field) {
      let refValue = eval("row." + field.model_property);
      let options = args[1].split(",");
      options.forEach((item) => {
        let parts = item.split(":");
        if (parts[0] == refValue) className = "badge badge-block badge-" + parts[1];
      });
    }
    var formattedValue = "<div class='" + className + "'>" + value + "</div>";
    return formattedValue;*/
  }
  formatImage(value:any, args: any[]){    
    if(value==null) return "";
    var formattedValue = `<div class="d-flex justify-content-left align-items-center"><div class="avatar-wrapper"><div class="avatar  me-1"><img src="../../../app-assets/images/avatars/2-small.png" alt="Avatar" height="32" width="32"></div></div><div class="d-flex flex-column"><a href="app-user-view.html" class="user_name text-truncate"><span class="fw-bold">Zsazsa McCleverty</span></a><small class="emp_post text-muted">@zmcclevertye</small></div></div>`;
    return formattedValue;
  }
  formatCurrency(value: any, args:any[]){
    if(value == null) return "0 €";
    var formattedValue = new Intl.NumberFormat("de-DE", {style: "currency", currency: "EUR"}).format(value);
    return formattedValue;
  }
  formatNumber(value: any, args:any[]){
    if(value == null) return "0";
    var formattedValue = new Intl.NumberFormat("de-DE").format(value)
    return formattedValue;
  }
  formatWWW(value: any, args: any[]) {
    if (value == null) return "";
    var formattedValue = "<a href='" + value + "' target='_blank'>" + value + "</a>";
    return formattedValue;
  }
  formatIcon(value: any, args: any){
    let options = args[1].split(",");
    let more_class = "";
    options.forEach((item) => {
      more_class += item + " ";
    });
    var formattedValue = "<i class='" + value + ' ' + more_class +"'></i>";
    return formattedValue;
  }

  preLazyLoad($event) {
    setTimeout(() => this.lazyLoad($event), 100);
  }

  lazyLoad($event) {
    var params = {
      
    };

    if(this.component.source!=null){
      if(this.component.source.params!=null && Array.isArray(this.component.source.params)){        
        this.component.source.params.forEach(param => {
          let value = eval(param.value);          
          if(typeof(value)!="undefined" && value!=null) params[param.name] = value;
        });
      }
    }
    this.loaderService.skipRequest('/api/' + this.component.source.url, params);
    this.viewsService.getTableData(this.component.source.url, params).subscribe(
      data => {                
        this.totalRows = data.totalRows;
        this.rows = data.rows;
        this.loading = false;
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        Promise.resolve(null).then(() => this.loading = false );
      }
    )
  }

  left(){
    this.onEvent.emit({ event: "component-left", index: this.index });
  }
  
  right(){
    this.onEvent.emit({ event: "component-right", index: this.index });
  }

  getAvatar(row:any){
    let ret = "";        
    if(this.component.avatar!=null){
      if(this.component.avatar.type == "initials"){
        this.component.avatar.fields.forEach(field => {
          var value = eval("row." + field.entityField?.model_property);
          if(value!=null) ret += value.substring(0, 1).toUpperCase();
        });     
      }
    } 
    return ret;
  }
  

  getData(row: any, type) {

    let ret = "";     
    var titleFields = this.component.fields.filter(m=>m.type == type && m.entityField != null);
     
    if (titleFields.length > 0) {
      //if (type == "subtitle") console.log(titleFields);

      let i = 1; 
      titleFields.forEach(field => {                          
        let property = field.entityField?.model_property;

        if (field.entityField.model_property_label != null && field.entityField.model_property_label != "") {
          property = field.entityField.model_property_label;
        }
        
        var value = "";
        try {
          if (field.entityField?.is_base_field) {
            value = eval("row." + property);
          } else {
            value = row.metadata[property]; // eval("row.metadata" + property);
            if (field.entityField?.control_type == "dropdown") {
              //obtener valor para el seleccionado          
              if (field.entityField.configuration.options?.type == "api") {
                //petición al servidor.
              } else {
                let temporalCombos = field.entityField.configuration.options.items;
                temporalCombos.forEach((item) => {
                  if (eval("item." + field.entityField?.configuration?.field_value) == value) {
                    value = eval("item." + field.entityField?.configuration?.field_text);
                  }
                });
              }
            } else if (field.entityField?.control_type == "dropdown-multiple") {
              //obtener valor para el seleccionado          
              if (field.entityField.configuration.options?.type == "api") {
                //petición al servidor.
              } else {
                let temporalCombos = field.entityField.configuration.options.items;
                let selectedValues: any = value;
                if (!(selectedValues instanceof Array)) selectedValues = [selectedValues];
                value = "";
                selectedValues.forEach(selectedValue => {
                  temporalCombos.forEach((item) => {
                    if (eval("item." + field.entityField?.configuration?.field_value) == selectedValue) {
                      if (value != "") value += ", ";
                      value += eval("item." + field.entityField?.configuration?.field_text);
                    }
                  });
                });
              }
            }
          }
        }catch(e){
          //console.log("Eval for row." + property + " fail!");
        }   

        if(field.type == "badge"){     
          var css = field.badge.filter(m => m.id == eval("row."+field.entityField.model_property));
          if(css.length == 1){
            let str = "<div class='p-badge p-badge-"+css[0].css+"'>"+value+"</div>";
            value = str;
          }                  
        }else{
          let formatFn = field.formatFn;
            if (formatFn == null && field.entityField.configuration != null && field.entityField.configuration.formatFn != null) {
              formatFn = field.entityField.configuration.formatFn;
            }
            if (formatFn != null) {
              var format = formatFn.split("|");
              if (format[0] == "date") value = this.formatDate(value, format);
              if (format[0] == "suffix") value = this.formatSuffix(value, format);
              if (format[0] == "phone") value = this.formatPhone(value, format);
              if (format[0] == "mail") value = this.formatMail(value, format);
              if (format[0] == "www") value = this.formatWWW(value, format);
              if (format[0] == "badge") value = this.formatBadge(field, row, value, format);
              if (format[0] == "image") value = this.formatImage(field, format);
              if (format[0] == "icon") value = this.formatIcon(value, format);
              if (format[0] == "currency") value = this.formatCurrency(value, format);
              if (format[0] == "number") value = this.formatNumber(value, format);
            }
        }
        if(value!=null && value.length>0 && field.type!='subtitle') ret += value + " ";
        if(value!=null && value.length>0 && field.type=='subtitle') ret += value + (i!=titleFields.length ? "<br>" : "");
        i++;
      });   
    } 
    return ret;
  }

  columns(){
    return this.component.fields.filter(m => m.type == "column");
  }
  

  configure(){
    const ref = this.dialogService.open(ViewComponentConfigureComponent,{
      data: {
        component: this.component,
        entity: this.entity
      },
      header: "Configuración de componente",
      width: '70%'
    });
    ref.onClose.subscribe((data:any) =>{
      if(data){
        this.component.fields = data.fields;
        this.component.title = data.title;
        this.component.class = data.class;
        this.component.height = data.height;
        this.onEvent.emit({ event: "view-save" });
      }
    })
  }

  onDblClick(item){
    this.onEvent.emit({ event: "dblclick", component: this.component.code, data: item });
  }

  onActionClick(action, item, $event) {
    $event.preventDefault();
    $event.stopPropagation();
    if(action == 'edit') action = {name: "edit"};
    this.onEvent.emit({ event: "action", component: this.component.code, action: action, data: item });
  }

  fireEvent(component:string, event:string, args:any){
    if(event=="reload"){
      this.preLazyLoad(null);
    }
  }

  isActionVisible(action: any, item: any) {
    let visible: boolean = true;
    if (action.ngIf != null) {
      visible = eval(action.ngIf);
    }
    return visible;
  }

  showColumnsSelector($event, fieldType) {
    this.allowedEntities = [];
    this.fieldType = fieldType;
    this.entity.fields.forEach(field => {
      if (this.allowedEntities.find(m => m.code == field.entity_code) == null) {
        this.allowedEntities.push({ code: field.entity_code, name: field.entity_name });
      }
    });
    this.allowedEntitiesFields = [];
    this.opColumns.toggle($event);
  }

  getAllowedEntityFields(entity_code: string) {
    let fields = this.entity.fields.filter(m => m.entity_code == entity_code);
    fields.forEach((field) => {
      var selected = this.component.fields.find(m => m.entity_field_id == field.id && m.type == this.fieldType);
      field.selected = selected != null;
    });
    return fields;
  }

  onFieldChange($event, field) {
    if ($event.checked) {
      //añadimos al final
      var viewField = {
        entity_field_id: field.id,
        entityField: field,
        model_property: field.model_property,
        type: this.fieldType
      };
      this.component.fields.push(viewField);
    } else {
      this.removeField(field.id);
    }
  }

  removeField(entity_field_id) {
    this.component.fields = this.component.fields.filter(m => (m.entity_field_id != entity_field_id && m.type == this.fieldType) || m.type != this.fieldType);
  }

}
